import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography, Box, useTheme, Button, Container } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

import {
  authActions,
  workflowActions,
  fileActions,
  validationActions,
} from "../../store/actions";
import {
  UseImage,
  InputField,
  CustomLoadingOverlay,
  LinkButton,
  Alert,
  Buttons,
  GenericContainer,
  GeoLocationGeneric,
  SelectLanguage,
} from "../../components";
import {
  getHash,
  ClearSession,
  coreFunctions,
  obtenerDireccionIP,
  IPDEFAULT,
  IsDevice,
} from "../../utils";
import ConfigurationComponent from "../Configuration/ConfigurationComponent";
import imaBarTop from "../../assets/imaBarTop.png";
// import Logotipo from "assets/DOC/icons/DS_Logo.svg";
import Logotipo from "assets/icon_Metlife_Header.jpg";
import ReCAPTCHA from "react-google-recaptcha";

import imageLoad from "../../assets/Loading_Overlay.gif";
import QRCode from "qrcode.react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { presentationCredentialActions } from "../../store/actions/PresentationCredentialActions";
import { persistence } from "../../store/persistence";
import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { msalConfig } from "../../msalConfig";
import LanguageIcon from "@mui/icons-material/Language";
import LoginMultiRol from "./LoginMultiRol";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const useStyles = makeStyles((theme) => ({
  imgTopStyle: {
    [theme.breakpoints.only("md")]: {
      width: "50% !important",
    },
    [theme.breakpoints.only("lg")]: {
      width: "50% !important",
    },
    [theme.breakpoints.only("xl")]: {
      width: "50% !important",
    },
  },
  containerForm: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      width: "95%",
    },
  },
  form: {
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  formAuth: {
    display: "flex",
    //justifyContent: 'space-evenly',
    flexDirection: "column",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const iniciarConexionSignalR = () => {
  const authenticatorUrl = process.env.REACT_APP_URL_VERIFY_CREDENTIALS;

  const connection = new HubConnectionBuilder()
    .withUrl(authenticatorUrl)
    .build();

  connection.start().catch((error) => console.error(error));

  return connection;
};

// sso permisions
const scopes = [
  "User.Read", // Leer datos básicos del usuario.
  "profile", // Acceso a información básica del perfil.
];

export default function LoginComponent(props) {
  const theme = useTheme();
  const formMethods = useForm({ mode: "onChange" });
  const { control, handleSubmit, register, formState } = useForm({
    mode: "onBlur",
  });
  const classes = useStyles();
  const { IsMobile } = IsDevice();

  const tokenSesion = sessionStorage.getItem("token");
  const [ipCurrent, setIpCurrent] = useState("");
  const [lat, setLat] = useState("12222");
  const [lon, setLon] = useState("22222");
  const [openConfig, setOpenConfig] = useState(false);
  const [sendCAPTCHA, setSendCAPTCHA] = useState(false);

  const [isAutoconsumo, setIsAutoconsumo] = useState(false);
  const [loadView, setLoadView] = useState(false);
  const [formChange, setFormChange] = useState(false);
  const [idRef, setIdRef] = useState("");
  const [requestCaptcha, setRequestCaptcha] = useState(false);

  const [tokenSR, setIToken] = useState("");
  const [qrValueVC, setQRValue] = useState("");
  const [isVisible, setMostrarElemento] = useState(false);
  const [isVisibleQR, setShowQR] = useState(true);
  const [seconds, setSeconds] = useState(180); // 3 minutos en segundos
  const [isActive, setIsActive] = useState(false);
  const [multirol, setMultirol] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);

  const { i18n, t } = useTranslation();

  const navigate = useNavigate();

  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const urlVC = useSelector((state) => state.PresentationVCRemote);
  const redux = useSelector((state) => state);
  const file = useSelector((state) => state.FileInfo);
  const stateCapcha = useSelector((state) => state.VALCAPTCHA);
  const clientIPs = useSelector((state) => state.GetClientIPsWithRefer);

  const dispatch = useDispatch();

  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});
  const isBrasilEnvironment =
    process.env.REACT_APP_ENVIRONMENT === "BRADEV" ||
    process.env.REACT_APP_ENVIRONMENT === "BRA";

  console.log("SSO::isAuthenticated", isAuthenticated);
  console.log("SSO::account", account);

  console.log("REDUX", redux);

  useEffect(() => {
    if (isActive && seconds > 0) {
      const timer = setTimeout(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setIsActive(false);
    }
  }, [isActive, seconds]);

  useEffect(() => {
    if (process.env.REACT_APP_CONST_IPS_CAPTCHA) {
      resetRecaptcha();
    } else {
      setShowCaptcha(true)
    }
  }, []);

  const resetRecaptcha = () => {
    if (showCaptcha) {
      window?.grecaptcha?.reset();
      setIdRef("");
    } else {
      dispatch(authActions.GetClientIPsWithRefer());
    }
  };

  useEffect(() => {
    if (clientIPs?.items !== undefined) {
      console.log('clientIPs', clientIPs)
      setShowCaptcha(clientIPs?.items.UseCapcha);
      if (clientIPs?.items.ReferNoCapcha !== null) {
        setIdRef(clientIPs?.items.ReferNoCapcha);
      } else {
        clientIPs?.items.UseCapcha && setIdRef("");
      }
    } else if (clientIPs?.error !== undefined) {
      // setShowMaintenanceView(true); //COMMENTED TO NOT SHOW MAINTENANCE VIEW
      // alert(clientIPs?.error);
      // dispatch(authActions.GetClientIPsWithRefer())
    }
  }, [clientIPs]);


  useEffect(() => {
    // sessionStorage.clear()
    ClearSession();
    // console.log("Se limpia session storage.")
    obtenerDireccionIP((ip) => {
      setIpCurrent(ip);
      // console.log("Dirección IP:", ip);
    });
    const conn = iniciarConexionSignalR();
    conn.on("ReceiveMessageGroup", (data) => {
      setIToken(data);
    });
    conn.on("ReceiveMessage", (data) => {
      console.log("dataAuth 01 ", data);
      const objetoJson = JSON.parse(data);
      if (objetoJson.requestStatus == "request_retrieved") {
        setShowQR(false);
      } else if (objetoJson.Body == null && objetoJson.IsOK == false) {
        Alert(
          {
            icon: "error",
            text: objetoJson.Messages,
            okbtntext: t("general_accept"),
          },
          () => {
            logoutUser();
          }
        );
      } else {
        sessionStorage.clear();
        sessionStorage.setItem(
          //Almacenar token opcion 1: SessionStorage
          "token",
          objetoJson.Body.Token
        );
        sessionStorage.setItem(
          "WorkFlowData",
          objetoJson?.Body?.WorkFlowData?.WorkFlowName
        );
        sessionStorage.setItem(
          //Borrar al cerrar sesión
          "userName",
          `${objetoJson.Body.UserLoginData.Name} ${objetoJson.Body.UserLoginData.FatherLastName || ""
          } ${objetoJson.Body.UserLoginData.MotherLastName || ""}`
        );
        sessionStorage.setItem(
          //Borrar al cerrar sesión
          "Rol",
          `${objetoJson.Body.UserLoginData.SecurityLoginData.Roles[0].Name}`
        );
        localStorage.setItem(
          //Borrar al cerrar sesión
          "AuthData",
          objetoJson.Body
        );
        localStorage.setItem("TotalStageGroups", 10);
        localStorage.setItem("CurrentStageGroup", 6);
        dispatch(authActions.AuthenticationQA(objetoJson));
        setFormChange(true);
      }
    });
  }, []); //Valor a evaluar, sí este cambia, el contenido del arrow se ejecutará

  useEffect(() => {
    let wfData = {
      Workflow_Id: 1,
      Workflow_Version: 1,
      // Apk_Version: "1.0.19",
      Apk_Version: "1.1.3",
      IMEI: "PWA",
    };
    // console.log("wfData......: ", auth.items)
    // console.log("wfData......: ", formChange)
    if (auth.items != undefined && formChange) {
      if (
        auth.items.UserLoginData.SecurityLoginData.Roles[0].Name ==
        "Usuario Autoconsumo"
      ) {
        setIsAutoconsumo(true);
      } else if (
        auth.items.UserLoginData.SecurityLoginData.Roles[0].Name == "Agente"
      ) {
        setIsAutoconsumo(false);
      } else {
        setIsAutoconsumo(false);
      }
      // console.log("auth.items.UserLoginData.SecurityLoginData.Roles......: ", auth.items.UserLoginData.SecurityLoginData.Roles)
      // console.log("wfData......: ", wfData)
      // dispatch(workflowActions.GetWorkflowDefinitions(wfData))
    } else if (auth.error != undefined && formChange) {
      setLoadView(false);
      setFormChange(false);
      Alert(
        {
          icon: "error",
          text: showErrorAuth(auth.error),
          okbtntext: t("general_accept"),
        },
        () => {
          window.grecaptcha.reset();
          setIdRef("");
        }
      );
    }
  }, [auth]); //Valor a evaluar, sí este cambia, el contenido del arrow se ejecutará

  // useEffect(() => {
  //   if (wf?.items != undefined && auth.items != undefined && formChange) {
  //     //TODO define si se va a presencial o autoconsumo
  //     console.log("wf?.items......: ", isAutoconsumo, auth.dataModules, auth.items.UserLoginData)
  //     ValidateRedirect()
  //     // // console.log("wfData..auth.dataModules ....: ", isAutoconsumo, auth.dataModules)
  //     // if (!isAutoconsumo && auth.dataModules?.dashboardData?.Name == "Dashboard") {
  //     //   if (auth.dataModules?.dashboardData?.Name == "Dashboard"
  //     //     || auth.dataModules?.generarSolicitudesData?.Name == "Generar Solicitudes") {
  //     //     let nextComponent = "SearchResultComponent"
  //     //     coreFunctions.DoNextStage({ navigate, nextComponent })
  //     //   }
  //     //   else if (auth.dataModules?.busquedaData?.Name == "Busqueda") {
  //     //     let nextComponent = "SearchResultComponent"
  //     //     coreFunctions.DoNextStage({ navigate, nextComponent })
  //     //   } else {
  //     //     let requestItems = {
  //     //       Stage: null,
  //     //       Id: null
  //     //     }
  //     //     NextStage(requestItems)
  //     //   }
  //     // } else {
  //     //   dispatch(fileActions.GetFileInfo(auth.items.UserLoginData.CurrentFileId))
  //     // }
  //     // setFormChange(false)
  //   } else if (wf.error != undefined && formChange) {
  //     setLoadView(false)
  //     Alert({
  //       icon: "error",
  //       text: wf.error,
  //       okbtntext: "Aceptar",
  //     });
  //   }
  // }, [wf])

  // useEffect(() => {
  //   if (file.items != undefined && formChange) {
  //     //Enviar a siguiente componente definido en el nucleo
  //     setLoadView(false)
  //     // setFormChange(false)
  //     // console.log("----sessionStorage.getItem('nivelRiesgo')----------------: ", sessionStorage.getItem('nivelRiesgo'), sessionStorage.getItem('TypeCaptureSelfieSdk'), sessionStorage.getItem('omitirValidacion'))
  //     let configs = {
  //       "FileId": file.items.Id,
  //       "OcrOnline": false,
  //       "CaptureSelfieSdk": (sessionStorage.getItem('TypeCaptureSelfieSdk') != undefined && sessionStorage.getItem('TypeCaptureSelfieSdk') != null || sessionStorage.getItem('TypeCaptureSelfieSdk') != "" ? sessionStorage.getItem('TypeCaptureSelfieSdk') : "FaceTec3D"),
  //       "SkipDocumentValidation": (sessionStorage.getItem('omitirValidacion') != undefined && sessionStorage.getItem('omitirValidacion') != null && sessionStorage.getItem('omitirValidacion') != "" ? Boolean(sessionStorage.getItem('omitirValidacion')) : false),
  //       "RiskLevel": (sessionStorage.getItem('nivelRiesgo') != undefined && sessionStorage.getItem('nivelRiesgo') != null || sessionStorage.getItem('nivelRiesgo') != "" ? sessionStorage.getItem('nivelRiesgo') : "Alto")
  //     }
  //     // console.log("----Configuraciones----Ejecutadas----values-----------------: ", configs)
  //     dispatch(fileActions.SetManualConfigurations(configs))
  //     console.log("----file.items----: ", file.items)
  //     if (file.items.Stage?.Roles?.filter(item => item.Name == "Mesa de control")?.length > 0) {
  //       Alert({
  //         icon: "warning",
  //         text: "Se está validando información, intente más tarde.",
  //         okbtntext: "Aceptar",
  //       });
  //     } else {
  //       NextStage(file.items)
  //     }
  //   }
  //   if (file.error != undefined && formChange) {
  //     // alert(file.error)
  //     setLoadView(false)
  //     setFormChange(false)
  //     Alert({
  //       icon: "error",
  //       text: file.error,
  //       okbtntext: "Aceptar",
  //     });
  //   }
  // }, [file])

  useEffect(() => {
    if (file.items != undefined && tokenSesion) {
      if (file.items.Status == "Solicitud Cancelada") {
        NextStage(file.items);
      } else {
        navigate("/main/WelcomePortal");
      }
    } else if (file.error != undefined) {
      // alert(file.error)
      setLoadView(false);
      setFormChange(false);
      Alert({
        icon: "error",
        text: file.error,
        okbtntext: t("general_accept"),
      });
    }
  }, [file]);

  useEffect(() => {
    if (auth.items != undefined && formChange && tokenSesion) {
      if (auth.roles && auth.roles.length > 0) {
        setMultirol(true);
        setLoadView(false);
        return;
      }
      ValidateRedirect();
    }
  }, [auth, isAutoconsumo]);

  let NextStage = (items) => {
    let nextStage = items.Stage;
    let stageName = nextStage.Name;
    let stageId = nextStage.Id;
    let folioId = items.Id;
    let stage = items;

    let nextComponent = coreFunctions.GetLegoNext(stageName);

    coreFunctions.DoNextStage({
      navigate,
      nextComponent,
      State: { stageName, stageId, stage, folioId },
    });
  };

  let handleOpenConfig = (event) => {
    // alert("Configuracion")
    setOpenConfig(true);
  };

  let handleCloseConfig = (event) => {
    // alert("Configuracion")
    setOpenConfig(false);
  };

  useEffect(() => {
    setLoadView(stateCapcha.loading);

    if (stateCapcha.items !== undefined && requestCaptcha) {
      setIdRef(stateCapcha.items?.ReferId);
    } else {
      setIdRef("");
    }
  }, [stateCapcha]);

  useEffect(() => {
    // console.log('params en login', id)
    // console.log('authauth', auth)
    if (urlVC?.objeto !== undefined) {
      setLoadView(false);
      setQRValue(urlVC.objeto.url);
    } else {
      setLoadView(false);
    }
  }, [urlVC]); //Valor a evaluar, sí este cambia, el contenido del arrow se ejecutará

  useEffect(() => {
    /* Cuando es redireccionado despues del login con Microsoft, se obtiene este account,
    no lo obtenemos con la instancia por que si tiene login activo con microsoft
    en automatico se logearia nuevamente solo al entrar a login*/
    if (isAuthenticated && account) {
      handleValidateToken(account);
    }
  }, [isAuthenticated, account]);

  useEffect(() => {
    const checkInteraction = async () => {
      try {
        await instance.handleRedirectPromise();
      } catch (error) {
        console.error(
          "Error durante la comprobación de la interacción:",
          error
        );
      }
    };
    checkInteraction();
  }, [instance]);

  //Acción login
  const submitLogin = (data) => {
    //Login
    // console.log("Data---------------: ", data["txtPassword"], " - Data: ", data)
    let hasPass = getHash(data["txtPassword"]);
    // console.log("hasPass---------------: ", hasPass)
    let dataRequest = {
      //Objeto a enviar a API login
      Username: data["txtUser"], //State del usuario
      SelfieB64: null,
      PasswordHash: hasPass,
      RequestDataInfo: {
        File_Id: null,
        Coordinates: {
          Latitude: lat,
          Longitude: lon,
        },
        SOVersion: "2",
        PhoneBrand: "5525397878",
        PhoneModel: "vr",
        IP: ipCurrent ?? IPDEFAULT,
        MacAddress: ipCurrent ?? IPDEFAULT,
        BrowserRefer: "chrome",
      },
      ReferId: idRef,
      // Tenant: "",
      // Password: data["txtPassword"], //State de la contraseña
    };
    console.log("dataRequest", dataRequest);
    // console.log("data login: send: ", dataRequest)
    dispatch(authActions.Authentication(dataRequest));
    setFormChange(true);
    setLoadView(true);
  };

  const handleLoginWithSSO = async () => {
    /* llama la instancia para abrir la pagina de login de microsoft
    se obtiene nuevamente la instancia por que no la borramos al cerrar sesion.
    esto para mantener la sesion de microsoft iniciada y al navegar a login se borra el
    account de useAccount */
    const response = await instance.handleRedirectPromise();
    if (isAuthenticated && response?.account) {
      return handleValidateToken(response?.account);
    }
    instance.loginRedirect({ scopes }).catch((e) => {
      console.error(e);
    });
  };

  let handleChangeCaptcha = (event) => {
    dispatch(validationActions.ValidateCAPTCHA(event));
    setRequestCaptcha(true);
  };

  const ValidateRedirect = () => {
    console.log(
      "....ValidateRedirect......: ",
      isAutoconsumo,
      auth,
      auth.dataModules,
      auth.items.UserLoginData
    );
    // console.log("wfData..auth.dataModules ....: ", isAutoconsumo, auth.dataModules)
    setMultirol(false);
    if (
      !isAutoconsumo &&
      auth.dataModules?.dashboardData?.Name == "Dashboard"
    ) {
      if (
        auth.dataModules?.dashboardData?.Name == "Dashboard" ||
        auth.dataModules?.generarSolicitudesData?.Name == "Generar Solicitudes"
      ) {
        let nextComponent = "SearchResultComponent";
        coreFunctions.DoNextStage({ navigate, nextComponent });
      } else if (auth.dataModules?.busquedaData?.Name == "Busqueda") {
        let nextComponent = "SearchResultComponent";
        coreFunctions.DoNextStage({ navigate, nextComponent });
      } else {
        let requestItems = {
          Stage: null,
          Id: null,
        };
        NextStage(requestItems);
      }
    } else {
      console.log("ValidateRedirect AQUI", auth);
      if (
        auth.items.UserLoginData.SecurityLoginData.Roles[0].Name ==
        "Usuario Autoconsumo"
      ) {
        dispatch(
          fileActions.GetFileInfo(auth.items.UserLoginData.CurrentFileId)
        );
      } else {
        Alert(
          {
            icon: "error",
            text: t("user_not_permissions"),
            okbtntext: t("general_accept"),
          },
          () => {
            logoutUser();
          }
        );
      }
    }
    // setFormChange(false)
  };

  const getAccessToken = async (account) => {
    try {
      const response = await instance.acquireTokenSilent({
        ...msalConfig,
        account,
      });
      // Simular token ya ha expirado para pruebas
      //response.expiresOn = new Date(Date.now() - 10000); // Hace 10 segundos

      // Verifica si el token ha expirado
      if (response.accessToken && response.expiresOn > new Date()) {
        return response.accessToken;
      }

      // Si el token ha expirado, se lanza una nueva autenticación
      throw new Error("Token ha expirado");
    } catch (error) {
      console.log(
        "ERROR al obtener token SSO:",
        error.message,
        error instanceof InteractionRequiredAuthError,
        error.name
      );
      if (
        error instanceof InteractionRequiredAuthError ||
        error.message === "Token ha expirado"
      ) {
        console.log(
          "Se requiere interacción del usuario, volver a solicitar token..."
        );
        instance
          .loginRedirect({ scopes })
          .catch((e) => console.error("Error en loginRedirect:", e));
      } else {
        console.error("Error al adquirir token:", error);
      }
      return "";
    }
  };

  const handleValidateToken = async (account) => {
    //cuando Microsoft redirecciona a esta view cuando la
    //redireccion es correcta, hace login con MC
    try {
      const accessToken = await getAccessToken(account);
      if (!accessToken) return;
      const request = {
        Username: "",
        PasswordHash: "",
        SelfieB64: "",
        Email: account.username,
        Token: accessToken, //account.idToken,
        TokenId: account.idToken,
        EmployeeId: account.idTokenClaims.employeeid,
        RequestDataInfo: {
          File_Id: 0,
          Coordinates: { Latitude: "", Longitude: "" },
          SOVersion: "",
          PhoneBrand: "",
          PhoneModel: "",
          IP: "",
          MacAddress: "",
          BrowserRefer: "",
        },
      };
      dispatch(authActions.AuthenticationSSO(request));
      setFormChange(true);
      setLoadView(true);
    } catch (error) {
      console.log(error);
      Alert({
        icon: "error",
        title: "Ocurrio un error",
        text: error.message,
      });
    }
  };

  useEffect(() => {
    if (
      stateCapcha.items !== undefined &&
      stateCapcha.items !== null &&
      stateCapcha.items !== ""
    ) {
      setSendCAPTCHA(true);
    } else {
      setSendCAPTCHA(false);
    }
  }, [stateCapcha]);

  async function OnCredentialAccess() {
    setLoadView(true);
    dispatch(presentationCredentialActions.GetPresentation(null, true));
    setQRValue("");
    const vcPresent = dispatch(
      presentationCredentialActions.GetPresentation(tokenSR)
    );
    setMostrarElemento(!isVisible);
    console.log(vcPresent);
    setSeconds(180);
    setIsActive(true);
  }

  const returnLogin = () => {
    setMostrarElemento(false);
    setIsActive(false);
    setShowQR(true);
  };

  const logoutUser = () => {
    ClearSession();
    persistence.EndSession();
    navigate("/auth/");
    setIdRef("");
  };

  const showErrorAuth = (messageError) => {
    if (messageError.includes("user_invalid_password"))
      return t("login_user_invalid_password");
    if (messageError.includes("user_inactive")) return t("login_user_disabled");
    if (messageError.includes("user_tempblocked_"))
      return t("login_user_blocked_1", { minutes: messageError.split("_")[2] });
    return messageError;
  };

  return (
    <GenericContainer>
      <FormProvider {...formMethods} theme={theme}>
        <GeoLocationGeneric
          SuccessFN={(latitude, longitude) => {
            // console.log("succes,latitude, longitude ", latitude, longitude);
            setLat(latitude);
            setLon(longitude);
          }}
          ErrorFN={(error) => console.log("error", error)}
        />
        <Box
          sx={{
            right: 0,
            position: "absolute",
            width: "15%",
          }}
        >
          <SelectLanguage />
        </Box>
        {!isVisible && (
          <Container maxWidth="sm" sx={{ pb: 4 }}>
            {multirol ? (
              <LoginMultiRol />
            ) : (
              <Box>
                {loadView ? (
                  <CustomLoadingOverlay
                    active={loadView}
                    text={t("general_loading_message")}
                  />
                ) : null}
                <Box
                  sx={{
                    display: "fllex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <UseImage src={Logotipo} /* width={"95%"} */ />
                </Box>
                <br />
                <Box>
                  <Typography variant="h6" gutterBottom>
                    {t("login_sign_in")}
                  </Typography>
                  <Typography variant="subtitle" gutterBottom>
                    {t("see_you_again")}
                  </Typography>
                </Box>
                <InputField
                  inputType="text"
                  control={control}
                  register={register}
                  name="txtUser"
                  label={t("login_user")}
                  validations={{ required: true }}
                  required={true}
                  error={!!formState.errors["txtUser"]}
                  helperText={formState.errors["txtUser"]?.message}
                />
                <InputField
                  isPassword={true}
                  inputType="password"
                  control={control}
                  register={register}
                  name="txtPassword"
                  label={t("login_password")}
                  validations={{ required: true }}
                  required={true}
                  error={!!formState.errors["txtPassword"]}
                  helperText={formState.errors["txtPassword"]?.message}
                />
                {!showCaptcha ? null : (
                  <Box
                    sx={{
                      width: "100%",
                      marginTop: "2em",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <ReCAPTCHA
                      key={i18n.language}
                      hl={i18n.language}
                      size="large"
                      //style={{ width: '100%', display: "flex", textAlign: "center" }}
                      sitekey="6LeSrKEaAAAAAGnBnM94eRtpu1Z7PwnY3WpOyDvf"
                      onChange={handleChangeCaptcha}
                    />
                  </Box>
                )}
                <Box display="flex" justifyContent="center">
                  <LinkButton
                    LinkButtonText={t("login_recover_password")}
                    LinkButtonUrl="/auth/PasswordRecovery"
                  />
                </Box>

                <Buttons
                  disabledConfirm={idRef === ""}
                  onClickConfirm={handleSubmit(submitLogin)}
                  zIndex={10}
                />
                <Buttons
                  ConfirmButtonText={t("start_with_credential")}
                  onClickConfirm={() => OnCredentialAccess()}
                  zIndex={10}
                />
                <Buttons
                  ConfirmButtonText={t("sign_sso")}
                  onClickConfirm={() => handleLoginWithSSO()}
                  zIndex={10}
                />
                {/* <Box style={{ display: 'flex', justifyContent: 'center', alignContent: "center", textAlign: "center", marginTop: '1em' }}>
              <Box style={{ width: '100%' }}>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ height: 48, px: 10 }}
                  color="primary"
                  type={'button'}
                  onClick={OnCredentialAccess}
                >
                  Inicia sesión con credencial
                </Button>
              </Box>


            </Box> */}
                {/* <LinkButton LinkButtonText="¿Aún no tienes cuenta? Regístrate" LinkButtonUrl="/auth/RegisterComponent"
          marginBottom={DetecScreen()} /> */}
              </Box>
            )}
          </Container>
        )}

        {isVisible && (
          <Box className={classes.formAuth}>
            <Typography variant="h4" style={{ color: "#000000" }} gutterBottom>
              {t("sign_authenticator")}
            </Typography>
            {isActive == false ? (
              <Box>
                <Typography variant="subtitle" gutterBottom>
                  {t("login_not_confirmed")}
                </Typography>
                <Box sx={{ mt: 8 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{ height: 45, px: 10 }}
                    type={"button"}
                    onClick={() => returnLogin()}
                  >
                    {t("button_back")}
                  </Button>
                </Box>
              </Box>
            ) : (
              isVisibleQR && (
                <Box>
                  <Typography variant="subtitle" gutterBottom>
                    {t("scan_qr")}
                  </Typography>
                  <Box
                    sx={{ mt: 4 }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {qrValueVC == "" ||
                      qrValueVC == null ||
                      qrValueVC == undefined ? (
                      <Box
                        sx={{
                          display: "fllex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <UseImage src={Logotipo} width={"95%"} />
                      </Box>
                    ) : (
                      <QRCode size={290} value={qrValueVC} />
                    )}
                  </Box>
                </Box>
              )
            )}
            {/* && isActive == true */}
            {!isVisibleQR && isActive == true ? (
              <Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="subtitle" gutterBottom>
                    {t("login_confirm_access")}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", mt: 4 }}>
                  <UseImage src={imageLoad} type="img" />
                </Box>
              </Box>
            ) : null}
            {isActive && (
              <Box sx={{ mt: 2 }}>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ height: 45, px: 10 }}
                  type={"button"}
                  onClick={OnCredentialAccess}
                >
                  {t("login_user_password")}
                </Button>
              </Box>
            )}
          </Box>
        )}

        <ConfigurationComponent open={openConfig} close={handleCloseConfig} />
      </FormProvider>
    </GenericContainer>
  );
}

const DetecScreen = () => {
  if (IsDevice().IsIOS) {
    return 80;
  } else if (IsDevice().IsAndroid) {
    return 20;
  } else {
    return 1;
  }
};
